export const PAGE_SIZES = [10, 20, 30, 50, 100];

export const PAGINATION_SIZE = 20;

export const ANIMATION_DELAY = 50;
